// data/proyectos/proyectosData.ts
export interface Proyecto {
  titulo: string;
  imagen: string;
  descripcion: string;
  hasPage: boolean; // Indica si el proyecto tiene página propia
}

export const proyectosData: Proyecto[] = [
  {
    titulo: 'Sensorica',
    imagen: '/img/proyectos/sensorica_760.webp',
    descripcion: 'Sensórica es un sistema avanzado de análisis de muestras de agua que utiliza algoritmos de inteligencia artificial para identificar y clasificar contaminantes presentes en el agua. Este sistema permite una evaluación rápida y precisa de la calidad del agua, facilitando la toma de decisiones informadas para su tratamiento y gestión.',
    hasPage: true
  },
  {
    titulo: 'Raceway',
    imagen: '/img/proyectos/raceway_760.webp',
    descripcion: 'El sistema Raceway es una solución innovadora para el tratamiento y mejora de la calidad del agua en cuerpos de agua cerrados, como lagos y estanques. Utilizando una combinación de tecnologías avanzadas, incluyendo la circulación forzada del agua y la oxigenación, el sistema Raceway promueve un ambiente acuático saludable, previniendo la proliferación de algas y mejorando la biodiversidad. Esta tecnología es ideal para aplicaciones en acuicultura, parques recreativos y áreas naturales protegidas.',
    hasPage: true
  },
  {
    titulo: 'Drones',
    imagen: '/img/proyectos/drones_760.webp',
    descripcion: 'El uso de drones para la recopilación de datos en terrenos extensos o de difícil acceso. Esta tecnología permite realizar inspecciones rápidas y detalladas, facilitando la detección temprana de problemas ambientales.',
    hasPage: true
  },
  {
    titulo: 'Blooms',
    imagen: '/img/proyectos/blooms_760.webp',
    descripcion: 'Blooms es una solución innovadora diseñada para la detección temprana y el monitoreo de floraciones algales nocivas en cuerpos de agua. Utilizando sensores avanzados y análisis de datos en tiempo real, Blooms proporciona alertas tempranas sobre la presencia de algas tóxicas, ayudando a prevenir impactos negativos en la salud pública y los ecosistemas acuáticos.',
    hasPage: false
  },
  {
    titulo: 'Copernicus',
    imagen: '/img/proyectos/copernicus_760.webp',
    descripcion: 'El sistema Copernicus integra tecnologías de monitorización avanzada con plataformas de datos en la nube para ofrecer una solución completa de análisis de calidad de aguas. Permite el seguimiento en tiempo real de múltiples parámetros y la generación de informes automáticos para cumplimiento normativo.',
    hasPage: false
  },
  {
    titulo: 'Nanoburbujas',
    imagen: '/img/proyectos/nanoburbujas_760.webp',
    descripcion: 'El sistema de Nanoburbujas utiliza micro y nanoburbujas de oxígeno para mejorar la calidad del agua, promoviendo la limpieza de contaminantes y aumentando la oxigenación de la masa de agua. Esta tecnología favorece la recuperación de ecosistemas acuáticos, reduce la proliferación de algas y mejora la salud general del agua, ofreciendo una solución sostenible para cuerpos de agua industriales, recreativos o naturales.',
    hasPage: false
  },
  // {
  //   titulo: 'Balea',
  //   imagen: '/img/balea.webp',
  //   descripcion: 'El sistema de monitorización de la calidad del agua integrado en boya nos permite realizar mediciones periódicas en un punto preciso de una masa de agua. Se puede desplegar en aguas dulces o saladas. Permiten medir diversos puntos de la columna de agua mediante un sistema de mangueras bajo la boya. Estos puntos son colocados a medida de las necesidades del cliente. Las boyas poseen un sistema de paneles fotovoltaicos y conexión a internet 3G que le permite trabajar de forma autónoma durante largos períodos. Usamos baterías AGM de alta capacidad junto a reguladores MPPT que maximizan la energía obtenida.',
  //   hasPage: false
  // },
];